<!--
 * @Description: 油卡兑换
 * @Author: yl
 * @Date: 2021-06-08 14:41:50
 * @LastEditTime: 2021-06-08 15:02:47
 * @LastEditors: yl
-->
<template>
    <div class="topbar-container feeOilExchange">
        <zbList v-model="store" :minLen="6" :isKeep="true" class="container list"
            itemCls="shop-list-item list-item-inline" v-slot:default="{ item }">
            <div class="item shadow-bg" v-on:click="onInfoClick(item)">
                <div class="img bg-100" :style="{backgroundImage: 'url(' + item.smallImage + ')'}"
                    v-on:click.stop="onInfoClick(item)"></div>
                <div class="content">
                    <div class="fz_30 overflow">{{item.name}}</div>
                    <div class="bh bc ico-container">
                        <i class="bg-contain ico-maintenance"></i>
                        <span class="b1 overflow c_red fz_34">{{item.price}}</span>
                    </div>
                </div>
            </div>
        </zbList>
    </div>
</template>
<script>
import store from "@/utils/store";
import { gasCouponsList } from "@/api/fee";
import zbList from "@/components/data/List";
export default {
    name: "FeeOilExchange",
    components: { zbList },
    data() {
        return {
            store: {
                data: [],
                isVanLoading: false,
                isError: false,
                isFinished: true,
                proxy: {
                    getList: gasCouponsList
                }
            }
        };
    },
    created() {
        store.load(this.store);
    },
    methods: {
        onInfoClick(item) {
            this.$router.push({
                name: "feeOilExchangeInfo",
                params: { id: item.id, smallImage: item.smallImage }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.feeOilExchange {
    .list {
        background-color: #f7f8f8;
        padding: 0 20px;
    }
}
</style>
